(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsMaintenanceController', TabObjectsMaintenanceController);

    TabObjectsMaintenanceController.$inject = ['$uibModalInstance', 'entity', 'TabObjectsMaint'];

    function TabObjectsMaintenanceController($uibModalInstance, entity, TabObjectsMaint) {
        var vm = this;
        vm.tabObjects = entity;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.setMaintenance = function (tabObjects) {
            TabObjectsMaint.update({}, tabObjects, onSuccess, onError);
            function onSuccess(data) {
                tabObjects = data;
                $uibModalInstance.close(true);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
    }
})();
